<div>
    <div class="modal-header">
        <h4>
            {{ modalHeader }}
        </h4>
    </div>
    <div class="modal-body">
        <div>
            <textarea type="text"
                      class="form-control"
                      [(ngModel)]="modifiedText"
                      [attr.maxlength]="maxlength"
                      rows="10" style="overflow-y: auto;"></textarea>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-text-primary" (click)="closeModal()">{{ closeButtonText }}</button>
        <button type="button" class="btn btn-primary" (click)="saveModal()" [disabled]="modifiedText == null">{{ saveButtonText }}</button>
    </div>
</div>